import React from 'react';
import Subscription from '../../../../../../components/Subscription';

const FooterBanner = () => (
  <section className="subscription__wrapper">
    <div className="subscription__content">
      <header className="subscription__description">
        <h1 className="subscription__description__title">
          Latest trends, best design
          <br /> stories & tips
        </h1>
        <p className="subscription__description__content">
          Stay up to date with our most recent news and updates
        </p>
      </header>
      <Subscription />
    </div>
  </section>
);

export default FooterBanner;
